export default __webpack_public_path__ + "static/media/afterHero4.b1b0d5f9.png";